module.exports = __webpack_public_path__ + "v2-assets/static/media/ac-edit-summary-black.png";